import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import withStyles from '../../../../utils/withStyles';
import styles from './styles';


const PrimaryButton = ({
  classes, className, onClick, children, type, disabled,
}) => (
  <Button
    className={classnames(classes.button, className)}
    onClick={onClick}
    type={type}
    disabled={disabled}
  >
    {children}
  </Button>
);

PrimaryButton.defaultProps = {
  className: null,
  type: 'button',
  onClick: null,
  disabled: false,
};

PrimaryButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
};

export default withStyles(styles)(PrimaryButton);
